import React from 'react';
import { Outlet } from 'react-router-dom';

import { useCurrentUser } from '../../../hooks';
import MetaTags from '../../shared/MetaTags';
import ForumHeader from '../ForumHeader';
import styles from './styles.module.scss';

export const FORUM_BASE_TITLE = 'The Information Forum';

const DESCRIPTION =
  'The Information has a simple mission: deliver important, deeply reported stories about the technology business you won’t find elsewhere. Many of the most influential people in the industry turn to us for fresh information and original insight.';

export default function ForumLayout() {
  const { currentUser } = useCurrentUser();

  return (
    <div className={styles.forumLayout}>
      <MetaTags
        title={FORUM_BASE_TITLE}
        description={DESCRIPTION}
        ogImagePath={'/images/forum/twitter_forum.png'}
      />
      <ForumHeader currentUser={currentUser} />
      <Outlet />
    </div>
  );
}
